// extracted by mini-css-extract-plugin
export var container = "AddComment-module--container--gCLrE";
export var textarea = "AddComment-module--textarea--eB82q";
export var title = "AddComment-module--title--LRWOx";